module.exports = __webpack_public_path__ + "media/images/noaa_logo_pos-6c3e0d0f24cb98e1d235544e3216d676.png";